export const parseLocalDate = (dateStr: string) => {
  const [y, m, d] = dateStr.split('T')[0].split('-').map(Number)
  return new Date(y, m - 1, d)
}

export const formatPipelineDeadline = (dateStr?: string) => {
  if (!dateStr) return '-'
  const date = parseLocalDate(dateStr)
  return date.toLocaleDateString('pt-BR', { day: 'numeric', month: 'short' }).replace('.', '')
}

export const isPipelineDeadlineOverdue = (dateStr?: string) => {
  if (!dateStr) return false
  const deadline = parseLocalDate(dateStr)
  const now = new Date()
  now.setHours(0, 0, 0, 0)
  return deadline < now
}

export const getPipelineDeadlineTime = (dateStr?: string) => {
  if (!dateStr) return Number.MAX_SAFE_INTEGER
  return parseLocalDate(dateStr).getTime()
}
